export const addLink = (dispatch, link) => {
    dispatch({ type: 'ADD_LINK', payload: link })
}

export const deleteLink = (dispatch, link) => {
    dispatch({ type: 'DELETE_LINK', payload: link })
}

export const editLink = (dispatch, type, link) => {
    switch (type) {
        case 1:
            return dispatch({ type: 'UPDATE_LINK', payload: link });
        case 2:
            return dispatch({ type: 'UPDATE_SOCIAL_MEDIA_TYPE', payload: link });
        default:
            break
    }
}

export const editTheme = (dispatch, type, value) => {
    dispatch({ type: 'UPDATE_THEME_OBJECT', payload: { type: type, value: value } });
}

export const editInfo = (dispatch, type, value) => {
    dispatch({ type: 'UPDATE_INFO_OBJECT', payload: { type: type, value: value } });
}

export const updateLastProfile = (dispatch, profile) => {
    dispatch({ type: 'UPDATE_LAST_PROFILE', payload: profile })
}

export const updatePublish = (dispatch, publish) => {
    dispatch({ type: 'UPDATE_PUBLISH', payload: publish })
}

export const updateDraft = (dispatch, draft) => {
    dispatch({ type: 'UPDATE_DRAFT', payload: draft })
}

export const editPosition = (dispatch, destination, source) => {
    dispatch({ type: 'UPDATE_LINK_POSITION', payload: { destination: destination, source: source } })
}